export enum routePath {
  lk = "/lk/knowledge-base/",
  base = "/knowledge-base/",
}

export type RoutePathKeys = keyof typeof routePath;
